import AddNewsAPI from "./addNewsAPI";

const AddNewsService = async (data: FormData): Promise<any> => {
  try {
    return await AddNewsAPI(data);
  } catch (error) {
    throw error;
  }
};

export default AddNewsService;